import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import IndividualQuestionStudentHistory from '../molecules/IndividualQuestionStudentHistory';
import { AuthContext } from '../context/AuthContext';
import { CourseIDContext } from '../context/CourseIDContext';
import LoginPage from './NewLoginPage';

const IndividualQuestionHistoryPage = () => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const questionID = searchParams.get('questionId');

  const { isLoggedIn } = useContext(AuthContext);
  const { courseID } = useContext(CourseIDContext);

  const [status, setStatus] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!isLoggedIn) {
        setCheckingStatus(false);
        return;
      }
      try {
        const apiUrl = process.env.REACT_APP_API_BASE_URL;
        const storedUsername = sessionStorage.getItem('username');
        const response = await fetch(
          `${apiUrl}/api/authenticate/status/${courseID}/${storedUsername}`
        );
        if (response.ok) {
          const { status: role } = await response.json();
          setStatus(role?.toLowerCase());
        } else {
          console.error('Failed to fetch status.');
          setStatus('unauthorized');
        }
      } catch (error) {
        console.error('Error fetching status:', error);
        setStatus('error');
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchStatus();
  }, [isLoggedIn, courseID]);

  if (!isLoggedIn) {
    return <LoginPage onLoginSuccess={() => null} />;
  }

  if (checkingStatus) {
    return <div>Verifying permissions…</div>;
  }

  if (status && status !== 'instructor' && status !== 'ta') {
    return <Navigate to={`/${courseID}/`} replace />;
  }

  if (!username || !questionID) {
    return (
      <div style={{ padding: '24px' }}>
        Missing username or question information in the URL.
      </div>
    );
  }

  return (
    <IndividualQuestionStudentHistory
      username={username}
      questionID={questionID}
    />
  );
};

export default IndividualQuestionHistoryPage;
